export function EmbedError({ error }: { error: Error }) {
  const isNotFound =
    (error as { status?: number; statusCode?: number })?.status === 404 ||
    (error as { status?: number; statusCode?: number })?.statusCode === 404;

  return (
    <div className="flex w-full items-center justify-center bg-white px-4 py-8 text-center">
      <div>
        <p className="text-sm font-medium text-gray-500">
          {isNotFound ? 'המוצר לא נמצא' : 'שגיאה בטעינת הנתונים'}
        </p>
        <a
          href="https://pricedrop.co.il"
          target="_blank"
          rel="noopener noreferrer"
          className="mt-2 text-xs text-blue-500 hover:underline"
        >
          PriceDrop
        </a>
      </div>
    </div>
  );
}
